import { useEffect, useMemo, useState } from "react";
import { CalendarDays, Clock3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const DashboardDateTimeWidget = () => {
  const [now, setNow] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const locale = useMemo(() => navigator.language || "en-US", []);
  const timezone = useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC", []);

  const timeLabel = useMemo(
    () =>
      now.toLocaleTimeString(locale, {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: timezone,
      }),
    [locale, now, timezone],
  );

  const dateLabel = useMemo(
    () =>
      now.toLocaleDateString(locale, {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: timezone,
      }),
    [locale, now, timezone],
  );

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2 rounded-full border border-border/70 bg-card px-3 py-1.5">
        <Clock3 className="w-4 h-4 text-primary" />
        <span className="text-xs font-medium">{timeLabel}</span>
      </div>
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" className="rounded-full px-3 h-9">
            <CalendarDays className="w-4 h-4 mr-2 text-primary" />
            <span className="text-xs">{dateLabel}</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-2" align="end">
          <div className="px-2 pb-2">
            <p className="text-xs text-muted-foreground">{timezone}</p>
          </div>
          <Calendar mode="single" selected={selectedDate} onSelect={setSelectedDate} initialFocus />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default DashboardDateTimeWidget;
